// extracted by mini-css-extract-plugin
export var pageVisual = "ContentfulBlockVisual-module--pageVisual--RexJh";
export var imageOnly = "ContentfulBlockVisual-module--imageOnly--Y5JK9";
export var withBackgroundImage = "ContentfulBlockVisual-module--withBackgroundImage--nNOyY";
export var topBlocks = "ContentfulBlockVisual-module--topBlocks--uznpC";
export var bottomBlocks = "ContentfulBlockVisual-module--bottomBlocks--PG5ta";